import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';
import { FileItem } from '@app_modules/loan-applications/step1/file-item';

interface Response extends BackendResponse {}

interface Payload {
  id: number|string;
  investor_code: string;
}

export function useRemoveItemRateSheet(id: number|string, investor_code: string) {
  return useMutation({
    mutationFn: ({id, investor_code}: Payload) =>
      removeItemRateSheet({id: id, investor_code: investor_code}),
      onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(
          message(response.message),
        );
      } else {
        toast(
          message(`You has just removed investor code ${investor_code}.`),
        );
      }
      
      // queryClient.invalidateQueries({queryKey: DatatableDataQueryKey(`market-rates/${id}`)});
    },
    onError: err => showHttpErrorToast(err),
  });
}

function removeItemRateSheet({
  id, investor_code
}: Payload): Promise<Response> {
  return apiClient
    .post(`market-rates/${id}/remove-item`, {investor_code: investor_code})
    .then(r => r.data);
}

